import { X, CalendarDays } from "lucide-react";

function formatDate(iso) {
  if (!iso) return null;
  return new Date(iso).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
}

export default function AnnouncementPopup({ announcement, onClose }) {
  if (!announcement) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4">
      <div className="bg-white rounded-2xl shadow-2xl w-[480px] h-[480px] flex flex-col overflow-hidden">
        {/* Close button */}
        <div className="flex items-center justify-end px-5 pt-5 pb-2 flex-shrink-0">
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-700 transition rounded-full p-1 hover:bg-gray-100"
            title="Close"
          >
            <X size={20} />
          </button>
        </div>

        {/* Image — grows to fill available space */}
        {announcement.imageUrl && (
          <div className="flex-1 overflow-hidden mx-5 rounded-xl min-h-0">
            <img
              src={announcement.imageUrl}
              alt={announcement.title}
              className="w-full h-full object-cover"
            />
          </div>
        )}

        {/* Content */}
        <div className="px-5 pb-5 pt-3 flex-shrink-0">
          <h2 className="font-popinsSemiBold text-lg text-gray-800 leading-snug mb-1.5">
            {announcement.title}
          </h2>

          <p className="font-popinsRegular text-sm text-gray-600 leading-relaxed line-clamp-3">
            {announcement.message}
          </p>

          {announcement.expiryDate && (
            <div className="flex items-center gap-1.5 mt-3 text-xs text-gray-400 font-popinsRegular">
              <CalendarDays size={12} />
              <span>Valid until {formatDate(announcement.expiryDate)}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
